module.exports = __webpack_public_path__ + "img/jifen.6bf45724.png";